export default "__VITE_ASSET__DCF8bQN1__"